import React from "react";

export const SectionLabel = ({ children, variant = "light" }) => (
  <span
    className={`text-xs tracking-[0.28em] uppercase font-extrabold ${
      variant === "dark" ? "text-[#F5C518]" : "text-[#12495B]/70"
    }`}
  >
    {children}
  </span>
);

export const PageHero = ({ label, title, subtitle }) => (
  <section className="relative grain overflow-hidden bg-[#12495B] text-white">
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-28">
      <span className="text-xs tracking-[0.28em] uppercase font-extrabold text-[#F5C518]">{label}</span>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed font-normal">{subtitle}</p>
      )}
    </div>
  </section>
);
